"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var findErrors_1 = require("lib/functions/findErrors");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var rules = {};
var NextStepsInformationForm = (function (_super) {
    __extends(NextStepsInformationForm, _super);
    function NextStepsInformationForm(props) {
        var _this = _super.call(this, props) || this;
        _this.errors = {};
        _this.onChange = _this.onChange.bind(_this);
        _this.json_data = props.model.json_data;
        _this.onModel = _this.onModel.bind(_this);
        _this.isValid = _this.isValid.bind(_this);
        props.model.dispatcher.addListener(_this.onModel);
        return _this;
    }
    Object.defineProperty(NextStepsInformationForm.prototype, "dataStore", {
        get: function () {
            return this.props.model.dataStore;
        },
        enumerable: true,
        configurable: true
    });
    NextStepsInformationForm.prototype.onModel = function () {
        this.json_data = this.props.model.json_data;
        this.forceUpdate();
    };
    NextStepsInformationForm.prototype.onChange = function (id, value) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.log("Id", id);
                console.log("Value", value);
                this.json_data[id] = value;
                this.forceUpdate();
                return [2];
            });
        });
    };
    NextStepsInformationForm.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.dispatcher.dispatch();
                this.props.model.addValidateFunction("NextStepsInformationForm validateApplication", this.isValid);
                return [2];
            });
        });
    };
    NextStepsInformationForm.prototype.componentWillUnmount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.removeValidateFunction("NextStepsInformationForm validateApplication");
                this.props.model.dispatcher.removeListener(this.onModel);
                return [2];
            });
        });
    };
    NextStepsInformationForm.prototype.isValid = function () {
        console.log("Validate NextStepsInformationForm");
        var json_data = this.props.model.json_data;
        var specialRules = rules;
        var _a = findErrors_1.findErrors(this.json_data, specialRules), isValid = _a.isValid, errors = _a.errors;
        this.errors = errors;
        console.log("Form errors", this.errors);
        return isValid;
    };
    NextStepsInformationForm.prototype.render = function () {
        var model = this.props.model;
        var json_data = model.json_data;
        return (React.createElement("div", null,
            React.createElement("section", { className: "section-content scw" },
                React.createElement("h2", { className: "section-title-spa" }, "Next Steps"),
                React.createElement("article", null,
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-xs-12 col-md-12 space-bottom" },
                            React.createElement("ol", null,
                                React.createElement("li", null,
                                    "Submit this application for admissions with the following documentation:",
                                    React.createElement("ol", { type: "a" },
                                        React.createElement("li", null, "Proof of completion of secondary education (or equivalent) such as a High School Diploma, G.E.D. or Homeschooling documents"),
                                        React.createElement("li", null, "Submit a copy of a government issued identification such as a driver\u2019s license"),
                                        React.createElement("li", null, "If you would like to be evaluated for transfer credit from another cosmetology program, submit official transcripts from the school"),
                                        React.createElement("li", null, "Student enrolling in the 900 hour student instructor program must have 1 year of experience, in a salon servicing guest, as a licensed cosmetologist, barber, barber stylist, esthetician, or nail technician. Prospective student instructor students with less than one year as a licensed professional must obtain permission from the school Director to enroll. Students must also provide a copy of a valid and current cosmetology, nail technologist, esthetician, barber or barber-stylist license."),
                                        React.createElement("li", null, "Student enrolling in the 500 hour (with 2 years or more of cosmetology experience) must provide a copy of a valid and current cosmetology, nail technologist, esthetician, barber or barber-stylist license."))))))))));
    };
    __decorate([
        mobx_1.observable
    ], NextStepsInformationForm.prototype, "errors", void 0);
    NextStepsInformationForm = __decorate([
        mobx_react_1.observer
    ], NextStepsInformationForm);
    return NextStepsInformationForm;
}(react_1.Component));
exports.NextStepsInformationForm = NextStepsInformationForm;
//# sourceMappingURL=data:application/json;base64,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